
import { computed, defineComponent, toRefs } from "vue";

export default defineComponent({
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { isActive } = toRefs(props);
    const classes = computed(() => ({
      "adm-tabs-tab": true,
      "adm-tabs-tab--selected": !!isActive.value,
    }));

    return { classes };
  },
});
